<section class="nosotros">
	<div class="nosotros-titulo">
		<img src="assets/images/banners/nosotros.jpg" alt="Nosotros" loading="lazy"/>
	</div>
	<div class="nosotros-informacion">
		<div>
			<div>
				<img src="assets/images/paw.png" alt="Pawerful Pet Shop" loading="lazy"/>
			</div>
		</div>
		<div>
			<div>
				<h1>¿Quiénes somos?</h1>
				<p>
					En el 2015 iniciamos nuestro viaje en México, socios 100% mexicanos con productos hechos por manos mexicanas y un nombre que parte del juego de palabras <i>PAW</i> (del Inglés, pata) y <i>POWERFUL</i> (del Inglés, poderoso). Comenzamos creando y materializando nuestras ideas para las mascotas que amábamos, también en memoria de aquellas que nos esperan en el camino, para disfrute de las que hemos rescatado, adoptado, pero, sobre todo, para aquellos amigos que amamos, aunque seamos de distintas especies.
				</p>
				<p>
					Buscamos que cada socio, colaborador, costurero, administrador, repartidor comparta nuestra pasión por el cuidado y bienestar de nuestros amigos mascotas. Que disfruten de su belleza natural, su compañía y la fuerza espiritual que nos comparten todos los días. Para entender a nuestros clientes, comprender que nuestros productos deben agregar valor tanto a humanos como animales, brindarles opciones que sean útiles, cómodas, innovadoras y resuelvan los retos que enfrentan en la vida cotidiana.
				</p>
				<p>
					Para nosotros las mascotas son amigos de distinta especie que forman parte de la familia, entendida de la forma más amplia, diversa y universal, porque donde están quienes amamos, está nuestro hogar, en Pawerful somos familia y es siempre un placer recibirles en nuestra casa, física o virtual, ¡bienvenidos!
				</p>
			</div>
		</div>
	</div>
	<section class="nosotros-informacion-extra">
		<p>
			Los productos Pawerful están hechos en México y el juego de palabras al que hace alusión el nombre de la marca parte de una conciencia de empoderamiento animal y total respeto a la naturaleza de las mascotas, no los humaniza, porque esto es en sí otra forma de maltrato. Convive en armonía con seres sintientes de otras especies, brindándoles libertad, comodidad, seguridad y estética.
		</p>
		<p>
			Nos dirigimos a un público con un profundo amor y respeto por la vida, la naturaleza y la armonía con seres de otras especies.
		</p>
		<p>
			Nuestro mercado es exigente, busca proporcionar comodidad, seguridad, estética y un gran valor añadido en materiales y acabados que garanticen que nuestros productos tendrán larga vida, pero sobre todo, generan una buena experiencia para sus mascotas, que son sus amigos y miembros de su familia.
		</p>
		<p>
			Nuestros artículos brindan la mejor experiencia para animales y humanos, brindan la seguridad, confort, funcionalidad y belleza que se requieren para garantizar que las mascotas tendrán una vida plena al usarlos.
			Ofrecemos una marca nacional de alta calidad.
		</p>
		<p>
			Cuidamos los detalles: gran calidad de materiales, tejidos, costuras, herrajes, comodidad, además probamos todos nuestros diseños a fin de brindar una experiencia hipoalergénica, resistente, cómoda y de alta funcionalidad.
			Nuestros productos pueden realizarse bajo medidas específicas o materiales que el comprador decida. Al ser fabricantes, es posible adaptarla.
		</p>
		<p>
			Tenemos ubicaciones céntricas.
			Buscamos brindar una asistencia personalizada y una venta consultiva, por lo que nuestros colaboradores reciben capacitación constante de cada uno de los fabricantes.
			Amamos a los animales, no vendemos productos que no sustenten altos estándares de calidad para su mejor preservación.
		</p>
	</section>
	<app-contacto></app-contacto>
	<div class="nosotros-servicios">
		<div>
			<h1>
				Nuestros Servicios
			</h1>
			<section>
				<div>
					<figure>
						<img src="assets/images/servicios/sucursales.webp" alt="Sucursales" loading="lazy">
					</figure>
					<figcaption>
						<h2>Sucursales</h2>
						<p>
							Actualmente contamos con {{listaSucursales.length}} sucursales. En todas encontrarás todo para tu mascota y serás atendido por gente profesional en el cuidado de animales.
						</p>
						<a [routerLink]="['/ubicaciones']" class="fondo-purple">Conocer las sucursales</a>
					</figcaption>
				</div>
				<div>
					<figure>
						<img src="assets/images/servicios/ecommerce.webp" alt="E-Commerce" loading="lazy"/>
					</figure>
					<figcaption>
						<h2>E-Commerce</h2>
						<p>
							Conoce nuestra tienda online, cada semana encontrarás ofertas en gran diversidad de artículos. Contamos con envío gratis*.
						</p>
						<a [routerLink]="['/tienda']" class="fondo-blue">Ir a la tienda</a>
					</figcaption>
				</div>
				<div>
					<figure>
						<img src="assets/images/servicios/veterinaria.webp" alt="Veterinaria" loading="lazy"/>
					</figure>
					<figcaption>
						<h2>Veterinaria</h2>
						<p>
							Veterinarios profesionales para el cuidado de tu mayor amigo. En paerful sabemos lo importantes que son para ti.
						</p>
						<a [routerLink]="['/ubicaciones']" class="fondo-green">Hacer Cita</a>
					</figcaption>
				</div>
				<div>
					<figure>
						<img src="assets/images/servicios/estetica.webp" alt="Estética" loading="lazy"/>
					</figure>
					<figcaption>
						<h2>Estética</h2>
						<p>
							Dale a tu mascota el trato que se merece en nuestra estética para mascotas. Lo trataremos como un rey.
						</p>
						<a [routerLink]="['/ubicaciones']" class="fondo-green">Hacer Cita</a>
					</figcaption>
				</div>
			</section>
		</div>
	</div>
</section>